// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminController from "./admin_controller"
application.register("admin", AdminController)

import DropdownFilterController from "./dropdown_filter_controller"
application.register("dropdown-filter", DropdownFilterController)

import DropdownFilterFormController from "./dropdown_filter_form_controller"
application.register("dropdown-filter-form", DropdownFilterFormController)

import FormController from "./form_controller"
application.register("form", FormController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NewCategoryModalController from "./new_category_modal_controller"
application.register("new-category-modal", NewCategoryModalController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import PostFormController from "./post_form_controller"
application.register("post-form", PostFormController)

import PostPreviewController from "./post_preview_controller"
application.register("post-preview", PostPreviewController)

import PostPublishWidgetController from "./post_publish_widget_controller"
application.register("post-publish-widget", PostPublishWidgetController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SlideAnimationController from "./slide_animation_controller"
application.register("slide-animation", SlideAnimationController)
